import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('flexUiMenu', {
        template: require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/flex-ui/menu/flex-ui-menu.html'),
        controller: 'FlexUiMenuController',
        controllerAs: 'FlexUiMenuCtrl',
        bindings: {
            menuStructure: '<',
        },
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/flex-ui/menu/flex-ui-menu.component.ts